import { render } from "./MyHomeAccessEditor.vue?vue&type=template&id=f12ff108&scoped=true"
import script from "./MyHomeAccessEditor.vue?vue&type=script&lang=js"
export * from "./MyHomeAccessEditor.vue?vue&type=script&lang=js"

import "./MyHomeAccessEditor.vue?vue&type=style&index=0&id=f12ff108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12ff108"]])

export default __exports__